import React, { FC, ChangeEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getTranslator } from '../../i18n/getTranslator';
import searchTranslations from 'public/locales/en/search.json';
import {
    FilterWrapper,
    StyledDropdownWithLabel
} from './SearchInitiationMobile.styles';
import {
    DropdownWrapper,
    RightWrapper,
    LeftWrapper
} from '../../../search/common/Dropdown.styles';
import {
    updateFilter,
    resetFilters,
    minPriceWeeklySelector,
    maxPriceWeeklySelector,
    minPriceMonthlySelector,
    maxPriceMonthlySelector,
    priceFrequencySelector
} from '../../../reducers/filters';

const t = getTranslator(searchTranslations);

const priceLabel = t('filters.field.price.label');
const maxPriceLabel = t('filters.maxPriceLabelModal');
const priceFrequencyLabel = t('filters.priceFrequencyLabel');

export const SelectPriceToRent: FC = () => {
    const reduxDispatch = useDispatch();
    const {
        selectedValue: priceFrequencySelectedValue,
        options: priceFrequencyOptions
    } = useSelector(priceFrequencySelector);

    const { selectedValue: priceMinWeeklySelectedValue } = useSelector(
        minPriceWeeklySelector
    );

    const {
        selectedValue: priceMaxWeeklySelectedValue,
        options: priceMaxWeeklyOptions
    } = useSelector(maxPriceWeeklySelector);

    const { selectedValue: priceMinMonthlySelectedValue } = useSelector(
        minPriceMonthlySelector
    );

    const {
        selectedValue: priceMaxMonthlySelectedValue,
        options: priceMaxMonthlyOptions
    } = useSelector(maxPriceMonthlySelector);

    const priceMinMonthlyInt = parseInt(
        priceMinMonthlySelectedValue || '0',
        10
    );
    const priceMinWeeklyInt = parseInt(priceMinWeeklySelectedValue || '0', 10);

    const onPriceFrequencySelect = (evt: ChangeEvent<HTMLSelectElement>) => {
        reduxDispatch(updateFilter('priceFrequency', evt.currentTarget.value));
        if (evt.currentTarget.value === 'per_month') {
            reduxDispatch(resetFilters(['maxPriceWeekly', 'minPriceWeekly']));
        } else {
            reduxDispatch(resetFilters(['maxPriceMonthly', 'minPriceMonthly']));
        }
    };

    const onMaxMonthlyPriceChange = (evt: ChangeEvent<HTMLSelectElement>) => {
        reduxDispatch(updateFilter('maxPriceMonthly', evt.currentTarget.value));
    };

    const onMaxWeeklyPriceChange = (evt: ChangeEvent<HTMLSelectElement>) => {
        reduxDispatch(updateFilter('maxPriceWeekly', evt.currentTarget.value));
    };

    return (
        <FilterWrapper>
            <DropdownWrapper>
                <LeftWrapper>
                    <StyledDropdownWithLabel
                        id="mobile_price_frequency-filter"
                        data-testid="price_frequency-filter-select_mobile"
                        onChange={onPriceFrequencySelect}
                        value={priceFrequencySelectedValue}
                        name="priceFrequency"
                        label={priceFrequencyLabel}
                        aria-label="Price Frequency"
                        hasBorderRadius
                    >
                        {' '}
                        {priceFrequencyOptions
                            ? priceFrequencyOptions?.map((option) => (
                                  <option
                                      key={option.label}
                                      value={option.value}
                                  >
                                      {option.label}
                                  </option>
                              ))
                            : null}
                    </StyledDropdownWithLabel>
                </LeftWrapper>

                {priceFrequencySelectedValue !== 'per_week' && (
                    <RightWrapper>
                        <StyledDropdownWithLabel
                            onChange={onMaxMonthlyPriceChange}
                            value={priceMaxMonthlySelectedValue}
                            name="price_max_monthly"
                            id="price_max_monthly_mobile"
                            aria-label="Max Price monthly"
                            data-testid="max_price_monthly_data_testid"
                            label={maxPriceLabel}
                            hasBorderRadius
                        >
                            {priceMaxMonthlyOptions ? (
                                priceMaxMonthlyOptions?.map((option) => {
                                    if (
                                        option === null ||
                                        option.value === '0' ||
                                        priceMinMonthlyInt <=
                                            parseInt(option.value, 10)
                                    ) {
                                        return (
                                            <option
                                                key={`maxmonth-modal-${option?.value}`}
                                                value={option.value}
                                            >
                                                {option.label}
                                            </option>
                                        );
                                    }
                                })
                            ) : (
                                <option>{priceLabel}</option>
                            )}
                        </StyledDropdownWithLabel>
                    </RightWrapper>
                )}
                {priceFrequencySelectedValue == 'per_week' && (
                    <RightWrapper>
                        <StyledDropdownWithLabel
                            onChange={onMaxWeeklyPriceChange}
                            value={priceMaxWeeklySelectedValue}
                            name="price_max_weekly"
                            id="price_max_weekly_mobile"
                            aria-label="Max Price weekly"
                            data-testid="max_price_weekly_testid"
                            label={maxPriceLabel}
                            hasBorderRadius
                        >
                            {priceMaxWeeklyOptions ? (
                                priceMaxWeeklyOptions?.map((option) => {
                                    if (
                                        option === null ||
                                        option.value === '0' ||
                                        priceMinWeeklyInt <=
                                            parseInt(option?.value, 10)
                                    ) {
                                        return (
                                            <option
                                                key={`maxweek-modal-${option?.value}`}
                                                value={option.value}
                                            >
                                                {option.label}
                                            </option>
                                        );
                                    }
                                })
                            ) : (
                                <option>{priceLabel}</option>
                            )}
                        </StyledDropdownWithLabel>
                    </RightWrapper>
                )}
            </DropdownWrapper>
        </FilterWrapper>
    );
};
